var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFillW16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00053 11.8465L12.1205 14.3332L11.0272 9.64653L14.6672 6.4932L9.87386 6.08653L8.00053 1.66653L6.1272 6.08653L1.33386 6.4932L4.97386 9.64653L3.88053 14.3332L8.00053 11.8465Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFillW16);
export default __webpack_public_path__ + "static/media/star_fill_w16.09657437949118eaf4639753051584f8.svg";
export { ForwardRef as ReactComponent };